"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEmptyViewConfigRow = createEmptyViewConfigRow;
const custom_app_config_1 = require("./custom-app-config");
/**
 * sl-bpu6.4: Default row shape for a newly-provisioned Custom App.
 * Caller supplies `name`, `contentDbRef`, and optionally `isDefault`.
 * Everything else is the spec-defined neutral default.
 */
function createEmptyViewConfigRow(input) {
    const customAppConfig = input.dataSources
        ? (0, custom_app_config_1.createDefaultCustomAppConfig)({
            title: input.name,
            dataSources: input.dataSources,
            defaultLocale: input.defaultLocale,
        })
        : (0, custom_app_config_1.createCustomAppConfigFromContentDbRef)({
            name: input.name,
            contentDbRef: input.contentDbRef,
            defaultLocale: input.defaultLocale,
        });
    return {
        name: input.name,
        layoutType: 'list',
        rowDetailMode: 'none',
        inlineEdit: false,
        nav: 'none',
        search: false,
        pagination: 'none',
        hero: false,
        entryStyle: 'plain',
        tags: false,
        form: false,
        seoSlugCol: null,
        seoMetaCol: null,
        seoOgCol: null,
        seoCanonicalCol: null,
        seoRobotsIndex: true,
        seoTitleFormula: null,
        seoDescriptionFormula: null,
        seoOgImageFormula: null,
        contentDbRef: input.contentDbRef,
        customAppConfig,
        themeRef: null,
        bindings: {},
        isDefault: input.isDefault ?? true,
    };
}
